module.exports = __webpack_public_path__ + "img/logoew.13ecc24a.png";